import { Component, computed, input, output } from '@angular/core';

import { ACTION_BUTTONS } from '../constant/action-button.constant';
import { ActionButtonType } from '../enum/action-button.enum';
import { ButtonSeverity } from '../interfaces/button.interface';

// A list row's icon button: the action sets its icon, colour and tooltip.
// `title` feeds that tooltip, so the browser's own title is kept off the element.
@Component({
    standalone: false,
    selector: 'app-action-button',
    templateUrl: './action-button.component.html',
    host: { '[attr.title]': 'null' },
})
export class ActionButtonComponent {
    readonly action = input.required<ActionButtonType>();
    readonly routerLink = input<string[] | string | null>(null);
    readonly title = input<string | null>(null);
    readonly icon = input<string | null>(null);
    readonly severity = input<ButtonSeverity | null>(null);
    readonly disabled = input(false);
    readonly disabledReason = input<string | null>(null);
    readonly testId = input<string | null>(null);

    // For an action that opens a window rather than a page.
    readonly clicked = output<MouseEvent>();

    protected readonly button = computed(() => ACTION_BUTTONS[this.action()]);
    protected readonly label = computed(() => this.title() ?? this.button().title);
}
